import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';

import BackendService from '../services/backendService';

function useTenants(_?: boolean) {
  const tenantsCache = 'tenants';
  const router = useRouter();

  const tenantIdByUrl: string | undefined = router.query.tenantId as string | undefined;
  const [hasAccessToTenantByUrl, setHasAccessToTenantByUrl] = useState(true);
  const { data, isFetching, error } = useQuery(
    [tenantsCache, tenantIdByUrl],
    () => {
      return BackendService.instance.retrieveCurrentTenants();
    },
    {
      onSettled: res => {
        if (
          res &&
          res.user.availableTenants.find(
            t => t.tenantId === tenantIdByUrl || t.tenantId === data?.user.activeTenantId,
          )
        ) {
          setHasAccessToTenantByUrl(true);
        } else {
          setHasAccessToTenantByUrl(false);
        }
      },
      staleTime: 5000 * 60 * 5,
    },
  );

  const filteredTenants = useMemo(() => {
    if (data) {
      return {
        ...data,
        user: {
          ...data.user,
          availableTenants: data.user.availableTenants,
        },
      };
    }
  }, [data]);

  return {
    data,
    filteredTenants,
    error,
    isLoading: isFetching,
    hasAccessToTenantByUrl,
  };
}

export default useTenants;
